var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySmile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.3346C16.4167 27.2846 18.1417 26.668 20 26.668C21.8583 26.668 23.5833 27.2846 25 28.3346",
    stroke: "#202534",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 20C25.9192 20 26.6654 18.8807 26.6654 17.5C26.6654 16.1193 25.9192 15 24.9987 15C24.0782 15 23.332 16.1193 23.332 17.5C23.332 18.8807 24.0782 20 24.9987 20Z",
    fill: "#202534"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 20C15.9192 20 16.6654 18.8807 16.6654 17.5C16.6654 16.1193 15.9192 15 14.9987 15C14.0782 15 13.332 16.1193 13.332 17.5C13.332 18.8807 14.0782 20 14.9987 20Z",
    fill: "#202534"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 20.0007C3.33203 12.144 3.33203 8.21565 5.77203 5.77398C8.21536 3.33398 12.142 3.33398 19.9987 3.33398C27.8554 3.33398 31.7837 3.33398 34.2237 5.77398C36.6654 8.21732 36.6654 12.144 36.6654 20.0007C36.6654 27.8573 36.6654 31.7857 34.2237 34.2257C31.7854 36.6673 27.8554 36.6673 19.9987 36.6673C12.142 36.6673 8.2137 36.6673 5.77203 34.2257C3.33203 31.7873 3.33203 27.8573 3.33203 20.0007Z",
    stroke: "#202534",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySmile);
export default __webpack_public_path__ + "static/media/empty-smile.d45f3eba0233677d248d489db3eed072.svg";
export { ForwardRef as ReactComponent };